import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthRepository from '@/repositories/members/AuthRepository';

import { useMe } from './useMe';

export const useExchangeOneTimeToken = (
  uid: string | undefined,
  token: string | undefined,
  next?: string | null
) => {
  const authRepository = AuthRepository();
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (next) {
      navigate(`/${decodeURIComponent(next)}`);
      return;
    }
    navigate('/');
  };

  const meQuery = useMe({ redirectOnFailure: false, supressErrorMessage: true });

  const mutation = useMutation({
    mutationFn: () => authRepository.exchangeOneTimeToken(uid!, token!),
    onSuccess: () => {
      handleNavigate();
    },
    onError: () => {
      window.location.href = `${process.env.VITE_APP_WEBSITE_URL}/download-and-schedule/?title=Your%20link%20is%20no%20longer%20valid&message=Please%20download%20the%20app%20and%20log%20in%20to%20continue`;
    }
  });

  useEffect(() => {
    if (uid && token && !mutation.isPending && !mutation.isSuccess && !mutation.isError) {
      if (meQuery.isSuccess) {
        handleNavigate();
        return;
      }

      if (meQuery.isLoading) {
        return;
      }

      if (meQuery.isError) {
        mutation.mutate();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid, token, meQuery.isSuccess, meQuery.isLoading, meQuery.isError]);

  return mutation;
};
